"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_ui_1 = require("material-ui");
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var Input = function (_a) {
    var inputRef = _a.inputRef, props = __rest(_a, ["inputRef"]);
    return react_1.default.createElement(material_ui_1.TextField, __assign({}, props, { ref: inputRef }));
};
var debounceEnhancer = recompose_1.compose(recompose_1.defaultProps({ debounced: false, debouncedWait: 500 }), recompose_1.withProps(function (_a) {
    var onChange = _a.onChange, debouncedWait = _a.debouncedWait;
    return ({
        debouncedOnChange: lodash_1.debounce(onChange, debouncedWait),
    });
}), recompose_1.withState('valueDebounced', 'setValueDebounced', function (_a) {
    var value = _a.value;
    return value;
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (_a) {
        var debounced = _a.debounced, value = _a.value;
        var _b = this.props, oldValue = _b.value, setValueDebounced = _b.setValueDebounced;
        if (debounced && oldValue !== value) {
            setValueDebounced(value);
        }
    },
}), recompose_1.withHandlers({
    onChangeDebounced: function (_a) {
        var debouncedOnChange = _a.debouncedOnChange, setValueDebounced = _a.setValueDebounced;
        return function (value) {
            setValueDebounced(value);
            debouncedOnChange(value);
        };
    },
}), recompose_1.mapProps(function (_a) {
    var debounced = _a.debounced, valueDebounced = _a.valueDebounced, onChangeDebounced = _a.onChangeDebounced, debouncedOnChange = _a.debouncedOnChange, setValueDebounced = _a.setValueDebounced, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["debounced", "valueDebounced", "onChangeDebounced", "debouncedOnChange", "setValueDebounced", "value", "onChange"]);
    return (__assign({}, rest, { value: debounced ? valueDebounced : value, onChange: debounced ? onChangeDebounced : onChange }));
}));
var enhancer = recompose_1.compose(recompose_1.defaultProps({ value: '', onChange: lodash_1.noop }), recompose_1.renameProp('label', 'hintText'), debounceEnhancer, recompose_1.withHandlers({
    onChange: function (_a) {
        var onChange = _a.onChange;
        return function (_a) {
            var value = _a.target.value;
            return onChange(value);
        };
    },
}));
var ComposedInput = enhancer(Input);
exports.default = ComposedInput;
exports.FormInput = reduxFormWrappers_1.formWrapper(ComposedInput);
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Input.js
// module id = 161
// module chunks = 0